import { BaseDto } from '../base.dto';
import { ConfigurationDataTypeDto } from '../configurationDataType.dto';
import { PosConfigurationTypeEnum } from './posConfigurationType.enum';

export class PosConfigurationDto extends BaseDto {
  name: PosConfigurationTypeEnum;
  description?: string;
  dataType?: ConfigurationDataTypeDto;
  value?: string;
}
